<!-- <p-dock [model]="items" position="bottom">
    <ng-template pTemplate="item" let-item>
        <i [routerLink]="item.routerLink" [class]="item.icon" [pTooltip]="item.label" width="100%"></i>
    </ng-template>
</p-dock> -->
<router-outlet></router-outlet>
